import { z } from "zod";
import { PIN_MAXIMO, PIN_MINIMO, SENHA_MINIMA } from "../dominio";

export const email = z
  .string()
  .trim()
  .toLowerCase()
  .max(200)
  .pipe(z.email({ error: "E-mail inválido" }));

export const senhaNova = z
  .string()
  .min(SENHA_MINIMA, { error: `A senha precisa ter pelo menos ${SENHA_MINIMA} caracteres` })
  .max(200);

export const nome = z.string().trim().min(2, { error: "Informe o nome" }).max(120);

/** Data sem horário no formato AAAA-MM-DD. */
export const dia = z.iso.date({ error: "Data inválida (use AAAA-MM-DD)" });

export const centavos = z.number().int().min(0).max(100_000_000);

export const id = z.uuid({ error: "Identificador inválido" });

const ERRO_PIN = `O PIN tem de ${PIN_MINIMO} a ${PIN_MAXIMO} números`;
export const pin = z
  .string()
  .regex(/^[0-9]+$/, { error: ERRO_PIN })
  .min(PIN_MINIMO, { error: ERRO_PIN })
  .max(PIN_MAXIMO, { error: ERRO_PIN });
